
/**
 * Collection Wishlist Logic
 * Handles storing and retrieving favorite collections using localStorage.
 */

const COLLECTION_WISHLIST_KEY = 'bg-collection-wishlist';

const CollectionWishlist = {
    getWishlist: function () {
        const wishlist = localStorage.getItem(COLLECTION_WISHLIST_KEY);
        return wishlist ? JSON.parse(wishlist) : [];
    },

    saveWishlist: function (wishlist) {
        localStorage.setItem(COLLECTION_WISHLIST_KEY, JSON.stringify(wishlist));
        // Dispatch custom event for UI updates
        window.dispatchEvent(new CustomEvent('collection-wishlist-updated', { detail: { wishlist } }));
    },

    toggle: function (collectionData) {
        let wishlist = this.getWishlist();
        const index = wishlist.findIndex(item => item.handle === collectionData.handle);

        if (index > -1) {
            wishlist.splice(index, 1);
        } else {
            wishlist.push(collectionData);
        }

        this.saveWishlist(wishlist);
        return index === -1; // returns true if added, false if removed
    },

    isWishlisted: function (handle) {
        const wishlist = this.getWishlist();
        return wishlist.some(item => item.handle === handle);
    },

    initButtons: function () {
        const buttons = document.querySelectorAll('[data-collection-wishlist-button]');
        buttons.forEach(btn => {
            const handle = btn.getAttribute('data-collection-handle');
            if (this.isWishlisted(handle)) {
                btn.classList.add('is-wishlisted');
            } else {
                btn.classList.remove('is-wishlisted');
            }

            // Simple click handler
            if (!btn.hasAttribute('data-initialized')) {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    const data = {
                        handle: btn.getAttribute('data-collection-handle'),
                        title: btn.getAttribute('data-collection-title'),
                        image: btn.getAttribute('data-collection-image'),
                        url: btn.getAttribute('data-collection-url')
                    };
                    const added = this.toggle(data);
                    if (added) {
                        btn.classList.add('is-wishlisted');
                    } else {
                        btn.classList.remove('is-wishlisted');
                    }
                });
                btn.setAttribute('data-initialized', 'true');
            }
        });
    }
};

document.addEventListener('DOMContentLoaded', () => {
    CollectionWishlist.initButtons();
});

// Re-init when Shopify Section is loaded in customizer
document.addEventListener('shopify:section:load', () => {
    CollectionWishlist.initButtons();
});
